import { Box, Button } from "@mui/material";
import React from "react";
import CloudIcon from "@mui/icons-material/Cloud";

function ExperimentMachinePageHeader(props) {
  const id = props.id;

  return (
    <Box style={{ width: "100%", height: "10vh" }}>
      <CloudIcon
        style={{
          color: "#2877b9",
          marginRight: 8,
          marginLeft: 50,
          marginTop: 20,
        }}
      />
      <h2 style={{ color: "white", display: "inline",fontFamily: 'GmarketSansMedium'}}>연결 (Connecting)</h2>
    </Box>
  );
}

export default ExperimentMachinePageHeader;
